
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/december-2019-update",
      function () {
        return require("private-next-pages/blog/december-2019-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/december-2019-update"])
      });
    }
  